import { baseProductFilterSchema } from "@redotech/redo-model/product-filters/product-filters-db-parser";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getProductFiltersByTeam = {
  name: "getProductFiltersByTeam" as const,
  input: z.object({ teamId: z.string() }),
  output: z.array(
    z.intersection(z.object({ _id: zExt.objectId() }), baseProductFilterSchema),
  ),
};
